<wtf-dialogcontent [size]="'auto'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <div class="container">
        <div class="w-100-p">
            <ngx-datatable #myDataTable waResizeBox="content-box" (waResizeObserver)="onResize($event)"
                style="height: 30rem" class="material striped" [columnMode]="'force'" [headerHeight]="50"
                [footerHeight]="50" rowHeight="50" [rows]="rows" [count]="rows.length" [loadingIndicator]="isLoading"
                [offset]="page.offset" [externalPaging]="true" [scrollbarV]="true" [virtualization]="false"
                [limit]="page.limit" (page)="paginate($event)" [messages]="{
                emptyMessage: ('No hay registros que mostrar' | translate),
                totalMessage: ('Total de Registros' | translate),
                selectedMessage: false
            }">
                <ngx-datatable-column prop="creationDate" name="{{ 'Fecha' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

                <ngx-datatable-column prop="file" name="{{ 'Archivo' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

                <ngx-datatable-column prop="userId" name="{{ 'Id de usuario' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

                <ngx-datatable-column name="{{ 'Status' | translate }}" width="50" [flexGrow]="0.5">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.status | translate }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [width]="30" prop="fileRecordCreate" name="{{ 'Creados' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

                <ngx-datatable-column [width]="40" prop="fileRecordDuplicate" name="{{ 'Duplicados' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

                <ngx-datatable-column [width]="30" prop="fileRecordError" name="{{ 'Errores' | translate }}"
                    [flexGrow]="0.5"></ngx-datatable-column>

            </ngx-datatable>
        </div>
        <div class="d-flex align-content-end justify-content-end mt-2">
            <button mat-raised-button class="material-icons-outlined" aria-label="Cerrar"
                (click)="closeDialog()">Cerrar</button>
        </div>
    </div>
</wtf-dialogcontent>